import { i18n } from 'i18next';
import React from 'react';
import { I18nextProvider } from 'react-i18next';

type WithI18nProps = {
  i18nInstance?: i18n;
};

export const withI18n = <P extends object>(Component: React.ComponentType<P>) => {
  const WrappedComponent: React.FC<P & WithI18nProps> = ({ i18nInstance, ...props }) => {
    if (i18nInstance) {
      return (
        <I18nextProvider i18n={i18nInstance}>
          <Component {...(props as P)} />
        </I18nextProvider>
      );
    }

    return <Component {...(props as P)} />;
  };

  WrappedComponent.displayName = `withI18n(${Component.displayName ?? Component.name})`;

  return WrappedComponent;
};
